import React, { useEffect, useState } from "react";
import CreditCardProp from "../components/CreditCardProp";
import Button from "../components/Button";
import mastercard from "../assets/mastercard.jpg";
import Rupay from "../assets/Rupay.png";
import Visa from "../assets/Visa.png";
import CompItem2 from "../components/CompItem2";
import TextCompareStatus from "../pages/Card Comparison/TextCompareStatus";
import IconCompareStatus from "../pages/Card Comparison/IconCompareStatus";
import RatingComareStatus from "../pages/Card Comparison/RatingCompareStatus";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import BreadcrumbNav from "../components/BreadcrumbNav";
import PageSEO from "../components/SEO_Component/PageSEO";

//progress indicator
import CircularProgressIndicator from "../components/CircularProgress";
import CardComparisonPage from "./Card Comparison/CardComparisonPage";

const CreditCardComparison = () => {
  const { lang, cardIds } = useParams();

  function parseCardIds() {
    const [card1Id, card2Id] = cardIds.split("-vs-");
    return { card1Id, card2Id };
  }

  const [data, setData] = useState({});
  const [allCreditCards, setAllCreditCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { card1Id, card2Id } = parseCardIds();
  const location = useLocation();
  const navigate = useNavigate();

  const networkType = {
    Mastercard: mastercard,
    Rupay: Rupay,
    Visa: Visa,
  };

  const getNetworkTypeIcon = (type) => {
    return networkType[type];
  };

  const getRatingOfCard = (card) => {
    const full = card.stars_full;
    const half = card.stars_half;
    return `${full}.${half * 5}`;
  };

  window.scrollTo({
    top: 0,
    behavior: "instant",
  });

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}${lang}/credit-cards-compare/${cardIds}?debug=true`
        );
        const data = await response.json();
        setData(data);
        console.log(data.card1.title);

        setIsLoading(false);
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchData();
  }, [cardIds]);

  const handleViewEvent = (id) => {
    return `/${lang}/credit-card/${id}`;
  };

  const nav = [
    {
      caption: "Home",
      href: "/english",
    },
    {
      caption: "Credit Cards",
      href: "/english/credit-cards",
    },
    {
      caption: "Credit Cards Comparision",
      href: location.pathname,
    },
  ];

  return (
    <div className=" rounded-[10px] flex flex-col justify-center">
      {isLoading && (
        <div className="flex justify-center items-center h-screen">
          <CircularProgressIndicator />
        </div>
      )}

      {!isLoading && data && data.card1 && (
        <>
          <div className=" rounded-[10px] flex flex-col justify-center">
            <BreadcrumbNav pathSegments={nav} />
            {data.seo && <PageSEO seoData={data.seo} />}

            <div className="w-[90vw] mx-auto mt-10">
              <h1 className="ml-6 mb-6 font-montserrat font-semibold text-black text-[14px]">
                {data.card1.title} vs {data.card2.title}
              </h1>
              <div className="flex flex-row justify-center">
                <div className="flex-col items-center m-0 w-[45%] text-center">
                  <div className="flex items-center justify-center">
                    <img
                      className="w-[220px] h-[110.4px] md:w-[292px] md:h-[189px] rounded-2xl"
                      src={data.card1.image}
                      alt="Card Image1"
                    />
                  </div>
                  <p className="mt-2 text-black">{data.card1.title}</p>
                </div>
                <div className="flex items-center m-0 w-[10%] md:mx-auto">
                  <p className="md:text-[32px] md:mt-[8.1rem] mt-[5.8rem] pt-3 text-center font-montserrat font-bold text-[14px] text-black">
                    Vs
                  </p>
                </div>
                <div className="flex-col items-center m-0 w-[45%] text-center">
                  <div className="flex items-center justify-center">
                    <img
                      className="w-[220px] h-[110.4px] md:w-[292px] md:h-[189px] rounded-2xl bg-cover bg-center"
                      src={data.card2.image}
                      alt="Card Image2"
                    />
                  </div>
                  <p className="mt-2 text-black">{data.card2.title}</p>
                </div>
              </div>
            </div>

            <div className="flex flex-row justify-center mt-4">
              <div className="flex mx-auto md:pr-0 pr-6">
                <Link to={handleViewEvent(data.card1.id)}>
                  <Button
                    name="View Details"
                    width="83px md:w-[140px]"
                    height="h-[20px] md:h-[30px]"
                    borderradius="rounded-[40px]"
                    bg="bg-[#FFFFFF]"
                    displayflex="flex"
                    justifycontent="justify-center"
                    alignitems="items-center"
                    textcolor="text-[#00C6CA]"
                    textsize="text-[14px] md:text-[16px]"
                    fontweight="font-normal"
                    bordercolor="border-black"
                  />
                </Link>
              </div>
              <div className="flex mx-auto md:pr-2">
                <Link to={handleViewEvent(data.card2.id)}>
                  <Button
                    name="View Details"
                    width="83px md:w-[140px]"
                    height="h-[20px] md:h-[30px]"
                    borderradius="rounded-[40px]"
                    bg="bg-[#FFFFFF]"
                    displayflex="flex"
                    justifycontent="justify-center"
                    alignitems="items-center"
                    textcolor="text-[#00C6CA]"
                    textsize="text-[14px] md:text-[16px]"
                    fontweight="font-normal"
                    bordercolor="border-black"
                  />
                </Link>
              </div>
            </div>

            <div className="flex justify-center mt-4 md:mt-10 bg-[#00C6CA] p-1 rounded-full mx-6 md:mx-24">
              <h3 className="text-white font-medium">Credit Card Detail</h3>
            </div>
            <div className="flex-col rounded-lg shadow-xl mt-4 mx-6 md:mx-auto md:w-[85vw]">
              <TextCompareStatus
                title="Bank Name"
                card1={data.card1.bank.title}
                card2={data.card2.bank.title}
              />
              <RatingComareStatus
                title="Rating"
                card1={getRatingOfCard(data.card1)}
                card2={getRatingOfCard(data.card2)}
              />
              <IconCompareStatus
                title="Network Type"
                card1={getNetworkTypeIcon(data.card1.network)}
                card2={getNetworkTypeIcon(data.card2.network)}
              />
            </div>

            {/*Compare Section for the joining fee*/}

            <div className="flex justify-center mt-4 md:mt-10 bg-[#00C6CA] p-1 rounded-full mx-6 md:mx-24">
              <h3 className="text-white font-medium">Joining fee</h3>
            </div>
            <div className="flex-col rounded-lg shadow-xl mt-4 mx-6 md:mx-auto md:w-[85vw]">
              <TextCompareStatus
                title="Joining Fee"
                card1={data.card1.joining_fees}
                card2={data.card2.joining_fees}
              />
              <TextCompareStatus
                title="Renewal Fee"
                card1={data.card1.renewal_fees}
                card2={data.card2.renewal_fees}
              />
              <TextCompareStatus
                title="Late Fee"
                card1={data.card1.late_fees}
                card2={data.card2.late_fees}
              />
            </div>

            {/*Features & Benefits Section start*/}

            <div className="flex justify-center mt-4 md:mt-10 bg-[#00C6CA] p-1 rounded-full mx-6 md:mx-24">
              <h3 className="text-white font-medium">Features & Benefits</h3>
            </div>

            <div className="flex-col rounded-lg shadow-xl mt-4 mx-6 md:mx-auto md:w-[85vw]">
              <CompItem2
                first={data.card1.lounge === "Yes" ? true : false}
                second={data.card2.lounge === "Yes" ? true : false}
                title="Lounge Access"
              />
              <CompItem2
                first={data.card1.fuel_surcharge === "Yes" ? true : false}
                second={data.card1.fuel_surcharge === "Yes" ? true : false}
                title="Fuel Surcharge"
              />
            </div>

            {/* Key Feature Section */}

            <div className="flex justify-center mt-4 md:mt-10 bg-[#00C6CA] p-1 rounded-full mx-6 md:mx-24">
              <h3 className="text-white font-medium">Key Features</h3>
            </div>

            <div className="flex-col rounded-lg shadow-xl mt-4 mx-6 py-2 md:mx-auto md:w-[90vw]">
              <div className="flex justify-center border-b-[1px] px-6 md:pl-8 gap-8">
                <div
                  className="bulletPointUL text-black border-r-[1px] border-[#D9D9D9] flex-1"
                  dangerouslySetInnerHTML={{ __html: data.card1.features }}
                ></div>
                <div
                  className="bulletPointUL justify-center text-black items-center flex-1"
                  dangerouslySetInnerHTML={{ __html: data.card2.features }}
                ></div>
              </div>
            </div>

            {/*Editor's Review */}

            <div className="flex justify-center mt-4 md:mt-10 bg-[#00C6CA] p-1 rounded-full mx-6 md:mx-24">
              <h3 className="text-white font-medium">Editor's Review</h3>
            </div>

            <div className="flex-col rounded-lg shadow-xl mt-4 mx-6 md:mx-auto md:w-[90vw]">
              <div className="flex justify-center border-b-[1px] px-6 md:pl-8 gap-8">
                <div
                  className="bulletPointUL text-black border-r-[1px] border-[#D9D9D9] flex-1"
                  dangerouslySetInnerHTML={{ __html: data.card1.review }}
                ></div>
                <div
                  className="bulletPointUL justify-center text-black items-center flex-1"
                  dangerouslySetInnerHTML={{ __html: data.card2.review }}
                ></div>
              </div>
            </div>

            <div className="flex  justify-center mt-10 w-[85vw] md:w-full md:mt-20 text-center pt-5">
              <p className=" font-montserrat font-semibold text-[20px] md:text-[40px] text-black leading-[26.38px] text-[#5C5A5A] md:text-center">
                {data.heading1}
              </p>
            </div>

            <div className="flex flex-col items-center mb-10 md:mb-3 ">
              <div className="md:grid md:grid-cols-3 md:gap-4 md:mt-4 md:mb-4 md:mx-3">
                {data.similar.map((item, index) => {
                  return (
                    <div className="mt-8 md:mt-10" key={index}>
                      <CreditCardProp
                        title={item.title}
                        img={item.image}
                        joining_fees={item.joining_fees}
                        renewal_fees={item.renewal_fees}
                        id={item.id}
                        apply={item.apply_link}
                        isComparision={true}
                        onComparisionClick={() => {
                          navigate(
                            `/${lang}/credit-cards-compare/${
                              card2Id + "-vs-" + item.id
                            }`
                          );
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="flex  justify-center mt-10 w-[85vw] md:w-full md:mt-20 text-center pt-5">
              <p className=" font-montserrat font-semibold text-[20px] md:text-[40px] text-black leading-[26.38px] text-[#5C5A5A] md:text-center">
                {data.heading1}
              </p>
            </div>
            <div className="flex flex-col items-center mb-10 md:mb-3 ">
              <div className="md:grid md:grid-cols-3 md:gap-4 md:mt-4 md:mb-4 md:mx-3">
                {data.similar1.map((item, index) => {
                  return (
                    <div className="mt-8 md:mt-10" key={index}>
                      <CreditCardProp
                        title={item.title}
                        img={item.image}
                        joining_fees={item.joining_fees}
                        renewal_fees={item.renewal_fees}
                        id={item.id}
                        apply={item.apply_link}
                        isComparision={true}
                        onComparisionClick={() => {
                          navigate(
                            `/${lang}/credit-cards-compare/${
                              card2Id + "-vs-" + item.id
                            }`
                          );
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CreditCardComparison;
